var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-50",staticStyle:{"z-index":"9999"}},[_c('div',{staticClass:"h-full w-full flex items-center justify-center"},[_c('div',{staticClass:"load8"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }